import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function appealThemesReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', mapThemes(state.get('data'), action.payload));
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}

function mapThemes(data, payload) {
  const themesData = Map({ [`${payload.categoryCode}`]: payload.data });
  return data ? data.merge(themesData) : themesData;
}
